
























import TitleBar from '@/modules/core/components/TitleBar.vue';
import Tiles from '@/modules/core/components/Tiles.vue';
import CardWidget from '@/modules/core/components/CardWidget.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import DevicesTable from '../components/DevicesTable.vue';
import PushNotifDropdown from '../components/PushNotifDropdown.vue';

export default {
  name: 'device-list',
  components: {
    TitleBar,
    Tiles,
    CardWidget,
    CardComponent,
    DevicesTable,
    PushNotifDropdown,
  },
  data: (): any => ({}),
  computed: {
    titleStack(): string[] {
      return ['Admin', 'Terminaux'];
    },
  },
  methods: {},
};
